import React, { useEffect, useState } from 'react';

import { formatDate } from '../../utils/date'

import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import { fetchNoticeListData } from '../../services/noticeService';

import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import BasicTable from '../../components/Table/BasicTable';
import MobileBasicTable from '../../components/Table/MobileBasicTable';

import S from './Support.module.css';
import SearchInput from '../../components/Input/SearchInput';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import useInput from '../../hooks/useInput';
import { noticeHeaderData, noticeOptions } from './SupportData';
import Pagination from '../../components/Paging/Pagination';
import { isMobile } from '../../config';

const NoticePage = () => {

  const { pageIdx } = useParams();

  const [ntSearch, setNtSearch] = useInput({ search: '', type: 'A' });
  const [noticeBodyData, setNoticeBodyData] = useState([]);
  const [pagingInfo, setPagingInfo] = useState([]);
  const [totalCnt, setTotalCnt] = useState(0);

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 327);
  }, [location]);
  
  useEffect(() => {
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  const noticeListData = async (searchType, searchVal, pageIdx) => {
    const response = await fetchNoticeListData(null, searchType, searchVal, pageIdx);
    const ntData = response.ntList;
    setTotalCnt(response.totalCnt);

    if(ntData) {
      const bodyData = ntData.map((item, index) => ({
        num: { text: index+1+((pageIdx-1)*10), className: 'ntIdTableBorder' },
        title: { text: item.NT_TITLE, className: 'ntTableTitle' },
        writer: { text: '관리자', className: 'ntTableBorder' },
        date: { text: formatDate(item.NT_INPUT_DATE), className: 'ntTableBorder' },
        idx: item.NT_IDX,
        url: 'support/notice/detail'
      }));
      setNoticeBodyData(bodyData);
    }
    setPagingInfo(response.pageInfo);
  };
  
  useEffect(() => {
    noticeListData(ntSearch.type, ntSearch.search, pageIdx);
  }, [location, pageIdx]);

  const onPageChangeHandler = (pageNumber) => {
    navigate(`/support/notice/${pageNumber}`)
  }

  const handleSubmit = (e) => {
    if (e.key === 'Enter') {
      noticeListData(ntSearch.type, ntSearch.search, 1);
    }
  }

  return (
    <div>
      <HeaderComponents pageKey="support" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="support" />
        </div>
        <div className='com-content-wrap mt-200'>
          <div style={{minHeight:'650px'}}>
            {isMobile() ? (
              <>
                <div className={S.searchBar}>
                  <SearchInput type='text' options={noticeOptions} name='search' selectname= 'type' value={ntSearch.search} selectvalue={ntSearch.type} onChange={setNtSearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
                </div>
                <div className='mb-10' draggable>
                  <a>Total <span className={S.cntFont}>{totalCnt}</span>건</a>
                </div>
                <MobileBasicTable headers={noticeHeaderData} items={noticeBodyData} itemKey="noticeMobileTable" />
              </>
            ) : (
              <>
                <div className='mb-35' draggable>
                  <a>Total <span className={S.cntFont}>{totalCnt}</span>건</a>
                </div>
                <BasicTable headers={noticeHeaderData} items={noticeBodyData} itemKey="NT_IDX" />
                <div className={S.searchBar}>
                  <SearchInput type='text' options={noticeOptions} name='search' selectname= 'type' value={ntSearch.search} selectvalue={ntSearch.type} onChange={setNtSearch} onKeyPress={handleSubmit} selectclass={'searchSelect'} inputclass={'searchInput'}/>
                </div>
              </>
            )}
            <Pagination 
              currentPage={pagingInfo.curPage}
              totalPages={pagingInfo.totalPage}
              onPageChangeHandler={onPageChangeHandler}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoticePage;
